// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToolbarToggle__wrapper___1w2ji","wrapper--active":"ToolbarToggle__wrapper--active___3f9AV"};